import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const nameMessages = defineMessages({
  required: {
    id: 'cities.new.form.name.required',
    defaultMessage: 'The city is required'
  },
  max: {
    id: 'cities.new.form.name.max',
    defaultMessage: 'The name can be up to 255 characters'
  }
})

const paramMessages = defineMessages({
  required: {
    id: 'cities.new.form.param.required',
    defaultMessage: 'The param is required'
  },
  max: {
    id: 'cities.new.form.param.max',
    defaultMessage: 'The param can be up to 255 characters'
  }
})

const codeMessages = defineMessages({
  required: {
    id: 'cities.new.form.code.required',
    defaultMessage: 'The code is required'
  },
  max: {
    id: 'cities.new.form.code.max',
    defaultMessage: 'The code can be up to 4 characters'
  }
})

const stateMessages = defineMessages({
  required: {
    id: 'cities.new.form.state.required',
    defaultMessage: 'The state is required'
  }
})

const timezoneMessages = defineMessages({
  required: {
    id: 'cities.new.form.timezone.required',
    defaultMessage: 'The timezone is required'
  }
})

const countryCodeMessages = defineMessages({
  required: {
    id: 'cities.new.form.countryCode.required',
    defaultMessage: 'The Country is required'
  }
})

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
export const newCitySchema = (intl): TSFixMe => {
  return yup.object().shape({
    countryCode: yup.string().required(intl.formatMessage(countryCodeMessages.required)),
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(255, intl.formatMessage(nameMessages.max)),
    param: yup
      .string()
      .required(intl.formatMessage(paramMessages.required))
      .max(255, intl.formatMessage(paramMessages.max)),
    code: yup.string().required(intl.formatMessage(codeMessages.required)).max(4, intl.formatMessage(codeMessages.max)),
    stateCode: yup.string().required(intl.formatMessage(stateMessages.required)),
    timezone: yup.string().required(intl.formatMessage(timezoneMessages.required))
  })
}
